import React from "react";
import { FileText, Eraser, ArrowRight } from "lucide-react";

/**
 * Lightweight tab body — points to the two full-page surfaces
 * (Reconciliation Report + Write-off Review) where deep monthly
 * work happens. Keeps the home page glanceable while giving a clear
 * jump-off to the rich reports.
 */
export default function ReportsTab({ onOpenReconciliation, onOpenWriteOffs }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="reports-tab">
      <Card
        testid="reports-open-reconciliation"
        onClick={onOpenReconciliation}
        Icon={FileText}
        title="Reconciliation Report"
        body="Opening → purchases → breakage → closing, per item per site for any date range. Mirrors the manual CCG monthly report. Includes CSV + print."
      />
      <Card
        testid="reports-open-writeoffs"
        onClick={onOpenWriteOffs}
        Icon={Eraser}
        title="Write-off / Breakage Review"
        body="Reviewable log of every breakage in the period — item, site, qty, value at the period-correct rate, reason, who logged it. Sortable + CSV export."
      />
    </div>
  );
}

const Card = ({ testid, onClick, Icon, title, body }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className="text-left w-full bg-white border border-slate-200 rounded-2xl p-5 hover:border-olive/40 hover:bg-olive/[0.02] transition-colors group"
  >
    <div className="flex items-start gap-3">
      <div className="w-10 h-10 rounded-2xl bg-olive/10 grid place-items-center text-olive shrink-0">
        <Icon size={18} strokeWidth={1.8} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="text-base font-semibold text-slate-900">{title}</span>
          <ArrowRight size={14} className="text-slate-400 group-hover:text-olive transition-colors shrink-0" />
        </div>
        <p className="text-xs text-slate-500 mt-1.5 leading-relaxed">{body}</p>
      </div>
    </div>
  </button>
);
